// import { Navigate } from "react-router-dom";
// import { useAuthStore } from "../store/auth.store";

// const ProtectedRoute = ({ children }) => {
//   const isAuthenticated = useAuthStore(
//     (state) => state.isAuthenticated
//   );

//   if (!isAuthenticated) {
//     return <Navigate to="/" replace />;
//   }

//   return children;
// };

// export default ProtectedRoute;


import { Navigate } from "react-router-dom";
import {useAuthStore} from "../store/auth.store";
import { getFirstAllowedRoute } from '../utils/getFirstAllowedRoute';

const ProtectedRoute = ({ children, permission }) => {
  const { isAuthenticated, permissions } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  //if (permission && !hasPermission(permission)) {
  if (permission && !permissions[permission]) {
    const fallback = getFirstAllowedRoute(permissions);
    return <Navigate to={`/dashboard${fallback}`} replace />;
    // return <Navigate to="/users" replace />;
  }

  return children;
};

export default ProtectedRoute;
